
import { goToRouteBySearch } from '@/components/common/EnquiriesScreen/utils/goToRouteBySearch';
import { browserHistory } from '@/routing/browserHistory';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';

function useCustomerNavigation() {
  const goToCustomer = (customerId: string) => {
    const link = `/customers-new/${customerId}`;
    browserHistory.push(getParameterizedLink(link));
  };

  const goToCustomersBySearch = (searchText?: string) => {
    goToRouteBySearch(searchText);
  };

  return { goToCustomer, goToCustomersBySearch };
}

export default useCustomerNavigation;
